import api from "@/libs/axios";
import * as ep from "../../endpoints";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { hasError } from "@/utils/utils";
export default {
  namespaced: true,
  state: {
    methods: [],
    loading: false,
    working: false,
  },
  getters: {
    methods(state) {
      return state.methods;
    },
    loading(state) {
      return state.loading;
    },
    working(state) {
      return state.working;
    },
  },
  mutations: {
    setMethods(state, payload) {
      state.methods = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setWorking(state, payload) {
      state.working = payload;
    },
  },
  actions: {
    async getMethods({ commit }) {
      commit("setLoading", true);
      await api.get(ep.METHODS).then((res) => {
        commit("setMethods", res.data.data);
      });
      commit("setLoading", false);
    },

    async createMethod({ dispatch, commit }, payload) {
      commit("setWorking", true);
      try {
        const res = await api.post(ep.METHODS, payload);
        if (hasError(res.status)) {
          throw res.status;
        }
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم تحديث معلومات طريقة التبرع بنجاح ",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
        dispatch("getMethods");
      } catch {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تحديث معلومات طريقة التبرع ",
            icon: "AlertIcon",
            variant: "danger",
          },
        });
      } finally {
        commit("setWorking", false);
      }
    },

    async updateMethod({ commit, dispatch }, payload) {
      commit("setWorking", true);
      try {
        const res = await api.put(ep.METHOD_BY_ID(payload.id), payload);
        if (hasError(res.status)) {
          throw res.status;
        }
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم تحديث معلومات طريقة التبرع بنجاح ",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
        dispatch("getMethods");
      } catch {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تحديث معلومات طريقة التبرع ",
            icon: "AlertIcon",
            variant: "danger",
          },
        });
      } finally {
        commit("setWorking", false);
      }
    },
  },
};
